const matchCharacters = /[|\\{}()[\]^$+*?.]/g;

/**
 * Escapes a string literal for use as an argument in the standard RegExp constructor
 * @param  {String} str
 * @return {String}
 */
export const escapeRegexString = (str = '') =>
  str.replace(matchCharacters, '\\$&');

export function validateUrl(url, allowNoProtocol = false) {
  if (allowNoProtocol) {
    const allowNoProtocolRegex =
      /^(https?:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*(:[0-9]{1,5})?(\/.*)?$/gm;

    return allowNoProtocolRegex.test(url);
  }

  const validCharactersRegex =
    /^[-a-zA-Z0-9+&@#/%?=~_|!:,.;]*[-a-zA-Z0-9+&@#/%=~_|]$/i;
  const protocolRegex = /^(http|https):\/\/.+$/i; // Make sure we have 1 or more character after http:// or https://

  return protocolRegex.test(url) && validCharactersRegex.test(url);
}

/**
 * Performs joining within the array. For example, we can join 2 out of 3 groups (starting at 0)
 * of an array ['a','b','c','d','e','f','g','h'] to get ['ab','c','de','f','gh'].
 * Useful for RegEx splitting to combine groups that ought to be together.
 * @param {integer} joinGroupStart - index of a group that begins joining
 * @param {integer} joinGroupCount - number of groups joining with the group
 * @param {integer} groupCount - total number of groups
 * @param {string[]} arr - the array to perform joining on
 */
export function joinArrGroups(joinGroupStart, joinGroupCount, groupCount, arr) {
  const newArr = [];
  let currentGroupContent = '';
  const groupEnd = joinGroupStart + joinGroupCount;
  for (let i = 0; i < arr.length; i += 1) {
    const currentGroup = i % groupCount;
    if (currentGroup >= joinGroupStart && currentGroup < groupEnd) {
      currentGroupContent += arr[i];
      if (currentGroup === groupEnd - 1 || i === arr.length - 1) {
        newArr.push(currentGroupContent);
        currentGroupContent = '';
      }
    } else {
      newArr.push(arr[i]);
    }
  }
  return newArr;
}
